export const SET_GENERAL_DATA = 'SET_GENERAL_DATA'
export const SET_CLIENT_DATA = 'SET_CLIENT_DATA'
export const SET_CLIENT_SECTIONS = 'SET_CLIENT_SECTIONS'
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'
export const CHANGE_SIDENAV = 'CHANGE_SIDENAV'
export const CHANGE_TITLE = 'CHANGE_TITLE'
export const SET_CLIENT_PRESECTION = 'SET_CLIENT_PRESECTION'
